import { unauthenticatedApi } from "@/lib/api/client";

export interface ProductPurchaseNotificationRequest {
  billingFrequency: string;
  companyName?: string;
  invoiceId?: string;
  ownerEmail: string;
  ownerId?: string;
  ownerMobile?: string;
  ownerName: string;
  planPrice: string;
  platformId?: string;
  platformName?: string;
  productName: string;
  promoCode?: string;
  purchaseType: "kickstarter_upgrade" | "regular_subscription";
  stripeCustomerId?: string;
  stripeSubscriptionId?: string;
}

export interface ProductPurchaseNotificationResponse {
  data: {
    emailSent: boolean;
    recipient: string;
  };
  message: string;
  success: boolean;
}

/**
 * Send product purchase notification to payments team
 */
export async function sendProductPurchaseNotification(
  data: ProductPurchaseNotificationRequest,
): Promise<ProductPurchaseNotificationResponse> {
  return unauthenticatedApi
    .url("/notifications/product-purchase")
    .post(data)
    .json<ProductPurchaseNotificationResponse>();
}
